import { h, Component } from '@stencil/core';

@Component({
  tag: 'pk-countdown-item',
  styleUrl: './pk-countdown-item.scss',
  shadow: true,
})
export class PkCountdownItem {
  // Own Properties
  // ====================

  // Reference to host HTML element
  // ===================================

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // These methods cannot be called from the host element.
  // =======================================================

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    return (
      <div class="countdown-item--container inline-flex">
        <div class="inline-flex min-w-[--countdown-item--min-width] flex-col items-center">
          <div
            class="countdown-item--container__value box-border inline-flex content-center items-center justify-center border-[1px] border-solid p-[--countdown-item--padding-number] lining-nums"
            part="value"
          >
            <slot />
          </div>
          <div
            class="countdown-item--container__label mt-[--countdown-item--margin-top-label] font-inherit"
            part="label"
          >
            <slot name="label" />
          </div>
        </div>
        <div part="separator">
          <slot name="separator" />
        </div>
      </div>
    );
  }
}
